import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

function TableOnly({
  table_data,
  table_head,
  table_body,
  disableSorting = false,
  actionsOnEnd = false,
  actionsOnCenter = false,
  topRow = null,
  tableSize = "sm",
  hoverable = false,
  tableClassName = "",
}) {
  const [searchParams, setSearchParams] = useSearchParams();

  /*  All States
   ********************************************* */
  const [currPageData, setCurrPageData] = useState(null);

  // Seeded from the URL: a page loaded with ?order=asc already has a sort
  // applied, so the header should show the matching arrow rather than
  // defaulting to the descending one.
  const [isSortUp, setIsSortUp] = useState(
    () => searchParams.get("order") === "asc",
  );

  /*  All Functions
   ********************************************* */

  function handleColumnClick(col) {
    let selectedColumn = searchParams.get("sort");
    let isSortUp = searchParams.get("order") === "asc";
    // If the column is already selected, toggle the sort order

    if (selectedColumn === col) {
      isSortUp = !isSortUp; // Toggle sort order
    }

    if (isSortUp) {
      setIsSortUp(isSortUp);
      SortUpColumn(col);
    } else {
      SortDownColumn(col);
      setIsSortUp(isSortUp);
    }
  }

  function SortUpColumn(colName) {
    // Update Search Params
    setSearchParams((prev) => {
      let _prev = { sort: colName, order: "asc" };

      prev.entries().forEach(([key, value]) => {
        if (key !== "sort" && key !== "order") {
          _prev[key] = value;
        }
      });

      let _query = prev.get("query");
      if (_query) {
        _prev["query"] = _query;
      } else {
        delete _prev["query"];
      }
      return _prev;
    });
  }

  function SortDownColumn(colName) {
    // Update Search Params
    setSearchParams((prev) => {
      let _prev = { sort: colName, order: "desc" };

      prev.entries().forEach(([key, value]) => {
        if (key !== "sort" && key !== "order") {
          _prev[key] = value;
        }
      });

      let _query = prev.get("query");
      if (_query) {
        _prev["query"] = _query;
      } else {
        delete _prev["query"];
      }
      return _prev;
    });
  }

  useEffect(() => {
    if (table_data) {
      setCurrPageData(table_data);
    }
  }, [table_data]);
  return (
    <div className="d-flex flex-grow-1">
      <div className="flex-grow-1 d-flex flex-column ">
        {/* ************ Table Head  ************ */}
        <div className="table-responsive flex-grow-1">
          <table
            className={`table${tableSize ? ` table-${tableSize}` : ""}${
              hoverable ? " table-hover" : ""
            }${tableClassName ? ` ${tableClassName}` : ""}`}
          >
            <thead>
              <tr className="">
                {table_head?.map((item) => {
                  return (
                    <th
                      onClick={() => {
                        if (item?.value === "Actions" || disableSorting) {
                          return;
                        }
                        handleColumnClick(item?.value);
                      }}
                      key={item?.value}
                      role="button"
                      className={`text-nowrap ${
                        item?.name === "Actions"
                          ? `${actionsOnEnd && "text-end"} ${
                              actionsOnCenter && "text-center"
                            }`
                          : item?.centerAlign
                            ? "text-center"
                            : ""
                      }${item?.tight ? " px-1" : ""}`}
                    >
                      {item?.name}

                      {!disableSorting && (
                        <>
                          {item?.value !== "Actions" &&
                            item?.value === searchParams.get("sort") &&
                            isSortUp && (
                              <i className="mdi mdi-sort-alphabetical-ascending h4 ms-2"></i>
                            )}
                          {item?.value !== "Actions" &&
                            item?.value === searchParams.get("sort") &&
                            !isSortUp && (
                              <i className="mdi mdi-sort-alphabetical-descending h4 ms-2"></i>
                            )}
                        </>
                      )}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {/*      Table Data
               ********************************************* */}
              {topRow && topRow}
              {currPageData &&
                currPageData.map((item, index) =>
                  table_body(item, index, currPageData),
                )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default TableOnly;
